import React, { useEffect, useState } from "react";
import { Select } from "../../../components/ui/select.js";
import { Input } from "../../../components/ui/input.js";

const AUTRE_VALUE = "Autre";

// Select à choix fixes qui bascule en input libre quand "Autre" est
// sélectionné (ou si la valeur restaurée — brouillon, draft — ne
// correspond à aucune option connue). Revient automatiquement en select
// dès que la valeur redevient une option fixe, ce qui permet à
// "Réinitialiser le formulaire" (SignModif.js) de repasser le champ en
// select simplement en réaffectant une valeur par défaut connue.
function SelectOuAutre({ name, value, onChange, options, className = "" }) {
  const isOptionConnue = (val) => options.some((opt) => opt.value === val);

  const [modeAutre, setModeAutre] = useState(() => !!value && !isOptionConnue(value));

  useEffect(() => {
    if (isOptionConnue(value)) setModeAutre(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleSelectChange = (e) => {
    if (e.target.value === AUTRE_VALUE) {
      setModeAutre(true);
      onChange({ target: { name, value: "" } });
      return;
    }
    onChange(e);
  };

  const handleRevenir = () => {
    setModeAutre(false);
    onChange({ target: { name, value: options[0]?.value ?? "" } });
  };

  if (modeAutre) {
    return (
      <div className="flex items-center gap-2">
        <Input
          type="text"
          name={name}
          value={value}
          onChange={onChange}
          placeholder="Précisez..."
          className={className}
          autoFocus
        />
        <button
          type="button"
          onClick={handleRevenir}
          className="text-[11px] text-slate-400 hover:text-[#840040] underline whitespace-nowrap shrink-0"
        >
          Liste
        </button>
      </div>
    );
  }

  return (
    <Select name={name} value={value} onChange={handleSelectChange} className={className}>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
      <option value={AUTRE_VALUE}>Autre</option>
    </Select>
  );
}

export default SelectOuAutre;
